module.exports = __webpack_public_path__ + "static/img/u955.86e2b6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u955.svg
// module id = iMTU
// module chunks = 209